module.exports = __webpack_public_path__ + "img/wuzheng_logo.162431ee.jpg";